import React from "react";
import { useSelector} from 'react-redux';
import {SetMetaData} from './../../helper/page-title';
import DashAffiliate from './affiliate';

function DashboardMain(){
    SetMetaData("Dashboard", "", "");
    var userReduxData = useSelector(state => state.auth);
    userReduxData =  userReduxData && userReduxData.user_info ? JSON.parse(userReduxData.user_info) : null;
    const userRoleIds = userReduxData ? userReduxData.role_ids : [];
   
    return (
        <>
        {userRoleIds.includes(6) && (
            <DashAffiliate />
        )}
        </>
    )    
}

export default DashboardMain;